/** CoStar.Api.ConsumerUserData.ListingVerification.ListingVerificationStatus */
export var ListingVerificationStatus;
(function (ListingVerificationStatus) {
    ListingVerificationStatus[ListingVerificationStatus["None"] = 0] = "None";
    ListingVerificationStatus[ListingVerificationStatus["Approved"] = 1] = "Approved";
    ListingVerificationStatus[ListingVerificationStatus["Rejected"] = 2] = "Rejected";
    ListingVerificationStatus[ListingVerificationStatus["Suspicious"] = 3] = "Suspicious";
    ListingVerificationStatus[ListingVerificationStatus["Pending"] = 4] = "Pending";
    ListingVerificationStatus[ListingVerificationStatus["Obsolete"] = 5] = "Obsolete";
    ListingVerificationStatus[ListingVerificationStatus["Skipped"] = 6] = "Skipped";
})(ListingVerificationStatus || (ListingVerificationStatus = {}));
/** CoStar.Api.ConsumerUserData.ListingVerification.ListingVerificationSortOption */
export var ListingVerificationSortOption;
(function (ListingVerificationSortOption) {
    ListingVerificationSortOption[ListingVerificationSortOption["Unknown"] = 0] = "Unknown";
    ListingVerificationSortOption[ListingVerificationSortOption["ListingVerificationStatus"] = 1] = "ListingVerificationStatus";
    ListingVerificationSortOption[ListingVerificationSortOption["SubmissionDate"] = 2] = "SubmissionDate";
    ListingVerificationSortOption[ListingVerificationSortOption["Email"] = 3] = "Email";
})(ListingVerificationSortOption || (ListingVerificationSortOption = {}));
/** CoStar.Api.ConsumerUserData.ListingVerification.ListingVerificationSortDirection */
export var ListingVerificationSortDirection;
(function (ListingVerificationSortDirection) {
    ListingVerificationSortDirection[ListingVerificationSortDirection["Ascending"] = 0] = "Ascending";
    ListingVerificationSortDirection[ListingVerificationSortDirection["Descending"] = 1] = "Descending";
})(ListingVerificationSortDirection || (ListingVerificationSortDirection = {}));
/** CoStar.Api.ConsumerUserData.ListingVerification.ReasonCode */
export var ReasonCode;
(function (ReasonCode) {
    ReasonCode[ReasonCode["None"] = 0] = "None";
    ReasonCode[ReasonCode["IOvationRejected"] = 1] = "IOvationRejected";
    ReasonCode[ReasonCode["Reactivated"] = 2] = "Reactivated";
    ReasonCode[ReasonCode["InitialState"] = 3] = "InitialState";
    ReasonCode[ReasonCode["UserDeactivated"] = 4] = "UserDeactivated";
    ReasonCode[ReasonCode["IOvationAllowed"] = 5] = "IOvationAllowed";
    ReasonCode[ReasonCode["IOvationReviewed"] = 6] = "IOvationReviewed";
    /** @deprecated No longer valid */
    ReasonCode[ReasonCode["UnableToVerify"] = 7] = "UnableToVerify";
    /** @deprecated No longer valid */
    ReasonCode[ReasonCode["IncompleteInfo"] = 9] = "IncompleteInfo";
    ReasonCode[ReasonCode["SubletPaidListing"] = 10] = "SubletPaidListing";
    /** @deprecated No longer valid */
    ReasonCode[ReasonCode["LocatorOrBroker"] = 11] = "LocatorOrBroker";
    ReasonCode[ReasonCode["DuplicateListingSameUser"] = 12] = "DuplicateListingSameUser";
    ReasonCode[ReasonCode["Other"] = 13] = "Other";
    ReasonCode[ReasonCode["BelowMarketValue"] = 14] = "BelowMarketValue";
    ReasonCode[ReasonCode["InvalidAddressSuspicious"] = 15] = "InvalidAddressSuspicious";
    ReasonCode[ReasonCode["InvalidPhoneOrEmail"] = 16] = "InvalidPhoneOrEmail";
    ReasonCode[ReasonCode["NumberNotAssociatedWithListing"] = 17] = "NumberNotAssociatedWithListing";
    ReasonCode[ReasonCode["SafetyIdentityTheft"] = 18] = "SafetyIdentityTheft";
    ReasonCode[ReasonCode["DidNotAnswerEmailOrCall"] = 19] = "DidNotAnswerEmailOrCall";
    ReasonCode[ReasonCode["FairHousingViolation"] = 20] = "FairHousingViolation";
    ReasonCode[ReasonCode["FraudReported"] = 21] = "FraudReported";
    ReasonCode[ReasonCode["PreviouslyIdentifiedAsSuspicious"] = 22] = "PreviouslyIdentifiedAsSuspicious";
    ReasonCode[ReasonCode["RentChange"] = 40] = "RentChange";
    ReasonCode[ReasonCode["DepositChange"] = 41] = "DepositChange";
    ReasonCode[ReasonCode["RentAndDepositChange"] = 42] = "RentAndDepositChange";
    ReasonCode[ReasonCode["PhoneChange"] = 50] = "PhoneChange";
    ReasonCode[ReasonCode["EmailChange"] = 51] = "EmailChange";
    ReasonCode[ReasonCode["PhoneAndEmailChange"] = 52] = "PhoneAndEmailChange";
    ReasonCode[ReasonCode["DuplicateListingDifferentUser"] = 53] = "DuplicateListingDifferentUser";
    ReasonCode[ReasonCode["InvalidAddressRejected"] = 54] = "InvalidAddressRejected";
    ReasonCode[ReasonCode["WatermarkOnPhoto"] = 55] = "WatermarkOnPhoto";
    ReasonCode[ReasonCode["PhotoNotOfListing"] = 56] = "PhotoNotOfListing";
    ReasonCode[ReasonCode["NotFixedLocation"] = 57] = "NotFixedLocation";
    ReasonCode[ReasonCode["IdentifiablePersonInPhoto"] = 58] = "IdentifiablePersonInPhoto";
    ReasonCode[ReasonCode["OffMarket"] = 60] = "OffMarket";
    ReasonCode[ReasonCode["AddressDenylisted"] = 61] = "AddressDenylisted";
    ReasonCode[ReasonCode["LowRisk"] = 65] = "LowRisk";
    ReasonCode[ReasonCode["MediumRisk"] = 66] = "MediumRisk";
    ReasonCode[ReasonCode["HighRisk"] = 67] = "HighRisk";
    ReasonCode[ReasonCode["DocumentsNotReceived"] = 68] = "DocumentsNotReceived";
    ReasonCode[ReasonCode["DocumentsReceivedOnApprove"] = 69] = "DocumentsReceivedOnApprove";
    ReasonCode[ReasonCode["OpenListing"] = 70] = "OpenListing";
    ReasonCode[ReasonCode["LocationHeldByCustomer"] = 71] = "LocationHeldByCustomer";
    ReasonCode[ReasonCode["Roommate"] = 72] = "Roommate";
    ReasonCode[ReasonCode["InvalidEmailOrPhone"] = 73] = "InvalidEmailOrPhone";
    ReasonCode[ReasonCode["InvalidAddress"] = 74] = "InvalidAddress";
    ReasonCode[ReasonCode["BrokerListing"] = 75] = "BrokerListing";
    ReasonCode[ReasonCode["AutoApproved"] = 76] = "AutoApproved";
    ReasonCode[ReasonCode["SiftScoreHigh"] = 77] = "SiftScoreHigh";
    ReasonCode[ReasonCode["UserReported"] = 78] = "UserReported";
    ReasonCode[ReasonCode["SiftScoreMedium"] = 79] = "SiftScoreMedium";
    ReasonCode[ReasonCode["SiftScoreLow"] = 80] = "SiftScoreLow";
    ReasonCode[ReasonCode["AutoBlockedFromSift"] = 81] = "AutoBlockedFromSift";
    ReasonCode[ReasonCode["ManuallyReviewedInSift"] = 82] = "ManuallyReviewedInSift";
    ReasonCode[ReasonCode["AutoApprovedInSift"] = 83] = "AutoApprovedInSift";
    ReasonCode[ReasonCode["RoommateOffmarket"] = 84] = "RoommateOffmarket";
    ReasonCode[ReasonCode["ManuallyBlockedFromSift"] = 85] = "ManuallyBlockedFromSift";
    ReasonCode[ReasonCode["UserReportedAutoTermination"] = 86] = "UserReportedAutoTermination";
    ReasonCode[ReasonCode["AutoTerminationFromSift"] = 87] = "AutoTerminationFromSift";
    ReasonCode[ReasonCode["ManualTerminationFromSift"] = 88] = "ManualTerminationFromSift";
    ReasonCode[ReasonCode["InvalidPhone"] = 89] = "InvalidPhone";
    ReasonCode[ReasonCode["DuplicateListing"] = 90] = "DuplicateListing";
    ReasonCode[ReasonCode["PhoneOrEmailOrUrlLinkInDescription"] = 91] = "PhoneOrEmailOrUrlLinkInDescription";
    ReasonCode[ReasonCode["SubscriptionRequired"] = 92] = "SubscriptionRequired";
})(ReasonCode || (ReasonCode = {}));
/** CoStar.Api.ConsumerUserData.ListingVerification.Source */
export var Source;
(function (Source) {
    Source[Source["Unknown"] = 0] = "Unknown";
    Source[Source["SQLJob"] = 1] = "SQLJob";
    Source[Source["WebApplication"] = 2] = "WebApplication";
    Source[Source["IOSApplication"] = 3] = "IOSApplication";
    Source[Source["AndroidApplication"] = 4] = "AndroidApplication";
    Source[Source["MobileWeb"] = 5] = "MobileWeb";
})(Source || (Source = {}));
/** CoStar.Api.ConsumerUserData.ListingVerification.EcomProductType */
export var EcomProductType;
(function (EcomProductType) {
    EcomProductType[EcomProductType["None"] = 0] = "None";
    EcomProductType[EcomProductType["Premium"] = 466] = "Premium";
    EcomProductType[EcomProductType["PremiumPlus"] = 467] = "PremiumPlus";
    EcomProductType[EcomProductType["PremiumMax"] = 469] = "PremiumMax";
})(EcomProductType || (EcomProductType = {}));
/** CoStar.Api.ConsumerUserData.ListingVerification.EnterpriseListingStatus */
export var EnterpriseListingStatus;
(function (EnterpriseListingStatus) {
    EnterpriseListingStatus[EnterpriseListingStatus["Unknown"] = 0] = "Unknown";
    EnterpriseListingStatus[EnterpriseListingStatus["Active"] = 1] = "Active";
    EnterpriseListingStatus[EnterpriseListingStatus["Pending"] = 2] = "Pending";
    EnterpriseListingStatus[EnterpriseListingStatus["OffMarket"] = 3] = "OffMarket";
    EnterpriseListingStatus[EnterpriseListingStatus["Terminate"] = 4] = "Terminate";
    EnterpriseListingStatus[EnterpriseListingStatus["SubscriptionHold"] = 5] = "SubscriptionHold";
    EnterpriseListingStatus[EnterpriseListingStatus["Unpublished"] = 6] = "Unpublished";
    EnterpriseListingStatus[EnterpriseListingStatus["AwaitingVerification"] = 7] = "AwaitingVerification";
    EnterpriseListingStatus[EnterpriseListingStatus["UserDeleted"] = 8] = "UserDeleted";
})(EnterpriseListingStatus || (EnterpriseListingStatus = {}));
/** CoStar.Api.ConsumerUserData.ListingVerification.IOvationStatus */
export var IOvationStatus;
(function (IOvationStatus) {
    IOvationStatus[IOvationStatus["Unknown"] = 0] = "Unknown";
    IOvationStatus[IOvationStatus["Allow"] = 1] = "Allow";
    IOvationStatus[IOvationStatus["Review"] = 2] = "Review";
    IOvationStatus[IOvationStatus["Deny"] = 3] = "Deny";
})(IOvationStatus || (IOvationStatus = {}));
/** CoStar.Api.ConsumerUserData.ListingVerification.ContactHistoryIdentifierType */
export var ContactHistoryIdentifierType;
(function (ContactHistoryIdentifierType) {
    ContactHistoryIdentifierType[ContactHistoryIdentifierType["None"] = 0] = "None";
    ContactHistoryIdentifierType[ContactHistoryIdentifierType["Id"] = 1] = "Id";
    ContactHistoryIdentifierType[ContactHistoryIdentifierType["Email"] = 2] = "Email";
    ContactHistoryIdentifierType[ContactHistoryIdentifierType["PhoneNumber"] = 3] = "PhoneNumber";
    ContactHistoryIdentifierType[ContactHistoryIdentifierType["DeviceId"] = 4] = "DeviceId";
})(ContactHistoryIdentifierType || (ContactHistoryIdentifierType = {}));
/** CoStar.Api.ConsumerUserData.ListingVerification.EnumListingVerificationUserAnalytics */
export var EnumListingVerificationUserAnalytics;
(function (EnumListingVerificationUserAnalytics) {
    EnumListingVerificationUserAnalytics[EnumListingVerificationUserAnalytics["ContactId"] = 0] = "ContactId";
    EnumListingVerificationUserAnalytics[EnumListingVerificationUserAnalytics["EmailAddress"] = 1] = "EmailAddress";
    EnumListingVerificationUserAnalytics[EnumListingVerificationUserAnalytics["PhoneNumber"] = 2] = "PhoneNumber";
    EnumListingVerificationUserAnalytics[EnumListingVerificationUserAnalytics["DeviceId"] = 3] = "DeviceId";
})(EnumListingVerificationUserAnalytics || (EnumListingVerificationUserAnalytics = {}));
/** CoStar.Api.ConsumerUserData.ListingVerification.UserSearchCriteriaType */
export var UserSearchCriteriaType;
(function (UserSearchCriteriaType) {
    UserSearchCriteriaType[UserSearchCriteriaType["Unknown"] = 0] = "Unknown";
    UserSearchCriteriaType[UserSearchCriteriaType["Name"] = 1] = "Name";
    UserSearchCriteriaType[UserSearchCriteriaType["Email"] = 2] = "Email";
    UserSearchCriteriaType[UserSearchCriteriaType["ListingAddress"] = 3] = "ListingAddress";
})(UserSearchCriteriaType || (UserSearchCriteriaType = {}));
/** CoStar.Api.ConsumerUserData.ListingVerification.ListingSortOrder */
export var ListingSortOrder;
(function (ListingSortOrder) {
    ListingSortOrder[ListingSortOrder["Unknown"] = 0] = "Unknown";
    ListingSortOrder[ListingSortOrder["Name"] = 1] = "Name";
    ListingSortOrder[ListingSortOrder["EmailAddress"] = 2] = "EmailAddress";
    ListingSortOrder[ListingSortOrder["ListingAddress"] = 3] = "ListingAddress";
})(ListingSortOrder || (ListingSortOrder = {}));
